<template>
  <div class="container lang-dir" :style="{ 'flex-direction': 'row' }">
    <input
      type="checkbox"
      class="chkbox"
      v-if="$store.state.hasInternet"
      @change="$emit('click')"
      :checked="checked"
      :disabled="disabledPackage"
    />
    <div style="padding: 0px 8px; flex: 1">
      <div
        class="flex"
        style="
          font-size: 13px;
          justify-content: space-between;
          color: #000;
          font-size: 13px;
        "
        :style="{ opacity: disabledPackage ? 0.5 : 1 }"
      >
        <b
          ><p>{{ name }}</p></b
        >
        <p>
          {{ price.toLocaleString() }}
          {{ userSettings.settings["language"] == "en" ? "$ " : "₪ " }}
        </p>
      </div>
      <div
        class="flex"
        style="font-size: 11px; justify-content: space-between; color: #7b7b7b"
      >
        <p v-if="!hideBooksNum">
          {{ books.toLocaleString() }} {{ $t("general.books") }}
        </p>
        <p v-if="!hideBookListBtn" class="open-list" @click="$emit('openList')">
          {{ $t("lists.openList") }}
        </p>
      </div>
      <div v-if="disabledPackage">
        <p>
          {{ $t("personalArea.availableFromVersion") }} {{ packageVersion }}
          {{ $t("personalArea.only") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "name",
    "books",
    "price",
    "checked",
    "disabledPackage",
    "packageVersion",
    "hideBookListBtn",
    "hideBooksNum",
  ],
};
</script>

<style lang="scss" scoped>
.container {
  padding: 8px 0px;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.05);
  // margin-bottom: 8px;
  overflow-x: hidden;
}
p {
  margin: 0px;
}
.open-list {
  color: rgba(0, 0, 0, 0.7);
  font-size: 9px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.05);
  padding: 2px 5px;
  cursor: pointer;
}
.chkbox {
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.05);
  opacity: 1;
  position: relative;
  height: auto;
  width: auto;
}
</style>
